import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories, getCategoryBySlug } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || 'yingshi');

  useEffect(() => {
    window.scrollTo(0, 0);
    if (slug) setActiveCategory(slug);
  }, [slug]);

  const category = getCategoryBySlug(activeCategory);
  const articles = getArticlesByCategory(activeCategory);

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-20 text-center">
          <p className="text-foreground-500">分类不存在</p>
          <Link to="/" className="text-primary-600 hover:underline mt-4 inline-block">返回首页</Link>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: category.name },
          ]}
        />

        <section className="w-full py-10 md:py-14 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-6xl mx-auto">
              <div className="mb-8">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center">
                    <i className={`${category.icon} text-accent-600 text-lg`}></i>
                  </div>
                  <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                    {category.name}磁力网站导航
                  </h1>
                </div>
                <p className="text-foreground-600 text-sm md:text-base ml-13">{category.description}</p>
              </div>

              <div className="flex flex-wrap gap-2 mb-8">
                {categories.map(cat => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer ${
                      activeCategory === cat.slug
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                    }`}
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>

              {articles.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {articles.map(article => (
                    <Link
                      key={article.id}
                      to={`/article/${article.slug}`}
                      className="group bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-300 overflow-hidden cursor-pointer"
                    >
                      <div className="relative h-44 overflow-hidden">
                        <img
                          src={article.imageUrl}
                          alt={article.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                        <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 rounded-md bg-background-50/90 text-foreground-900 text-xs font-bold">
                          <i className="ri-star-fill text-amber-400 text-xs"></i>
                          {article.rating}
                        </div>
                        {article.isNew && (
                          <div className="absolute top-3 left-3">
                            <span className="px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                              新收录
                            </span>
                          </div>
                        )}
                      </div>
                      <div className="p-4">
                        <h3 className="font-heading font-bold text-foreground-900 mb-2 text-base group-hover:text-primary-600 transition-colors">
                          {article.title}
                        </h3>
                        <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                          {article.description}
                        </p>
                        <div className="flex flex-wrap gap-3 text-xs text-foreground-500">
                          <span className="flex items-center gap-1">
                            <i className="ri-speed-up-fill text-primary-500"></i> {article.speed}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-shield-check-fill text-accent-500"></i> {article.stability}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-database-2-fill text-secondary-600"></i> {article.resources}
                          </span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <p className="text-foreground-500 mb-4">该分类暂无收录网站</p>
                  <Link to="/" className="text-primary-600 hover:underline text-sm">返回首页</Link>
                </div>
              )}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}